<template>
  <el-row class="text-align-left">
    <el-col :span="24" class="banner">
      <div class="banner-image">
        <img src="@/assets/OOCL_logo.svg" class="oocl-logo">
      </div>
    </el-col>
    <el-col :xl="21" :lg="20" :md="19" :sm="18">
      <div class="info-body">
        <div class="info-body-title">Service exception, please try again or contact application support.</div>
      </div>
    </el-col>
    <Footer></Footer>
  </el-row>
</template>

<script>
import Footer from '@/components/Footer.vue';
export default {
  components: {
    Footer
  }
};
</script>

<style scoped>
  .text-align-left {
    text-align: left;
  }
  .banner{
    position: fixed;
  }
  .banner-image {
    background-image: url("../../assets/assessment_banner.jpg");
    height: 185px;
    background-repeat: no-repeat;
    background-position: center;
  }

  .oocl-logo {
    margin-top: 50px;
    height: 50px;
    padding-left: 48px;
    position: relative;
  }

  .info-body{
    margin: 50px 40px 0 40px;
    position: relative;
    top: 185px;
  }

  .info-body-title{
    color: #2d2d2d;
    font-weight: bold;
    font-size: 28px;
    margin-bottom: 35px;
  }

  /* RWD Support */
  @media screen and (max-width: 1200px) {
    .assessment-title {
      font-size: 36px;
    }
  }

  @media screen and (max-height: 900px){
    .assessment-steps{
      height: 400px;
    }
  }

  @media screen and (max-height: 800px){
    .assessment-steps{
      height: 320px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/error/Error.vue